export * from '@primeuix/themes/material/paginator';
export { default } from '@primeuix/themes/material/paginator';
